import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, SectionTag } from "./shared";

const FAQS = [
  {
    q: "Is it really 110,000 RPM?",
    a: "Yes — the brushless motor is rated up to 110,000 RPM, driving a 13-blade aviation aluminum fan that pushes a focused jet of up to 33 m/s. The infinitely variable speed dial lets you dial it down for delicate jobs.",
  },
  {
    q: "Will it damage my PC or camera gear?",
    a: "Used correctly, no. For electronics, hold it 15–20 cm away and use low speed, and stop fans from free-spinning by holding them gently. Full power is for outdoor jobs, cars and stubborn grime.",
  },
  {
    q: "How long does the battery last?",
    a: "The 8,000 mAh cell keeps it blasting far longer than a can of air ever could, and it recharges fast over USB-C. The 3-level display shows remaining power at a glance.",
  },
  {
    q: "What does it actually replace?",
    a: "Disposable canned air, primarily — one X8 outlives thousands of cans with no freezing propellant or chemicals. Owners also use it for car drying, campfires, BBQs, snow clearing and inflating pool toys.",
  },
  {
    q: "What's in the box?",
    a: "The X8 Violent Fan unit and a USB-C charging cable. It charges from any USB-C port, power bank or laptop.",
  },
  {
    q: "Shipping and returns?",
    a: "Flat $4.99 tracked shipping to the US, Canada, UK, Australia and most of Europe — orders ship within 24–48 hours. Every unit is covered by a 30-day money-back guarantee — if it doesn't blow you away, send it back.",
  },
];

export const FAQ = () => (
  <section id="faq" data-testid="faq-section" className="border-t border-steel">
    <div className="mx-auto grid max-w-[1600px] gap-12 px-5 py-24 md:px-10 md:py-36 lg:grid-cols-12">
      <Reveal className="lg:col-span-5">
        <SectionTag index="08" label="Intel" />
        <h2 className="mt-6 font-display text-3xl font-black uppercase leading-[0.95] tracking-tighter md:text-6xl">
          Questions,<br /><span className="text-outline">answered.</span>
        </h2>
        <p className="mt-6 max-w-sm text-sm leading-relaxed text-smoke md:text-base">
          Everything buyers ask before pulling the trigger on the X8.
        </p>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-7">
        <Accordion type="single" collapsible className="border border-steel bg-carbon" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-steel px-6 md:px-8" data-testid={`faq-item-${i}`}>
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="py-5 text-left font-display text-sm font-bold uppercase tracking-wide hover:text-volt hover:no-underline md:text-base"
              >
                <span className="mr-4 flex items-baseline gap-4">
                  <span className="font-mono text-[10px] text-volt">0{i + 1}</span>
                  {f.q}
                </span>
              </AccordionTrigger>
              <AccordionContent className="pb-6 pl-9 text-sm leading-relaxed text-smoke md:text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
